export default __webpack_public_path__ + "static/media/qp-logo-full.75915c36.png";